<template>
  <QBtn
    :class="
      `calculator-button font-nunito ${removeOpacity ? 'remove-opacity' : ''} ${greyBorder ? 'grey' : ''} ${
        tertiaryBorder ? 'tertiary-border' : ''
      }`.trim()
    "
    :disabled="disabled"
    :color="color"
    :outline="outline"
    :rounded="rounded && getIsCalculatorButtonRounded"
    :icon="iconDirection === 'left' ? finalisedIcon : undefined"
    :icon-right="iconDirection === 'right' ? finalisedIcon : undefined"
    @click="handleClick"
    :type="type"
    :loading="loading"
    :stack="stack"
    :style="styleProp"
  >
    {{ label }}
    <slot></slot>
  </QBtn>
</template>

<script>
import { QBtn } from 'quasar';
import { evaChevronLeft, evaChevronRight } from '@quasar/extras/eva-icons';
import { mapGetters } from 'vuex';

export default {
  name: 'CalculatorButton',
  props: {
    label: {
      type: String,
      default: ''
    },
    color: {
      type: String
    },
    outline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    hasChevronIcon: {
      type: Boolean,
      default: false
    },
    isNextStep: {
      type: Boolean,
      default: false
    },
    removeOpacity: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    },
    type: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    iconDirection: {
      type: String,
      default: 'right'
    },
    stack: {
      type: Boolean,
      default: false
    },
    greyBorder: {
      type: Boolean,
      default: false
    },
    tertiaryBorder: {
      type: Boolean,
      default: false
    },
    styleProp: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      chevronLeftIcon: evaChevronLeft,
      chevronRightIcon: evaChevronRight
    };
  },
  computed: {
    ...mapGetters({ getIsCalculatorButtonRounded: 'theme/getIsCalculatorButtonRounded' }),
    finalisedIcon: function () {
      let icon = this.icon;

      if (this.hasChevronIcon && this.iconDirection === 'left') {
        icon = this.chevronLeftIcon;
      }

      if (this.hasChevronIcon && this.iconDirection === 'right') {
        icon = this.chevronRightIcon;
      }

      return icon;
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  },
  components: { QBtn }
};
</script>

<style lang="sass">
.calculator-button.q-btn:not(.bg-secondary):not(.bg-primary):not(.q-btn--outline),
.calculator-button.q-btn:not(.bg-secondary):not(.bg-primary):not(.q-btn--outline)
  .q-btn__wrapper:before
    border: 1px solid #616161
  &.grey .q-btn__wrapper:before
    border: 1px solid $grey-4
  &.tertiary-border .q-btn__wrapper:before
    border: 1px solid var(--tertiary-color)
.calculator-button.q-btn
  height: 40px
  &.next-step
    min-height: auto;
    .q-btn__wrapper .q-btn__content
      // justify-content: space-between
      min-width: 200px!important
      svg
        margin: 0!important

  &.lease-inclusion-button
    min-height: auto;
    .q-btn__wrapper .q-btn__content
      justify-content: space-between
      min-width: 160px!important
      svg
      margin: 0!important
  &.selected, &.selected:disabled
    background: var(--q-color-secondary)
    color: #FFFFFF
    opacity: 1!important
  .q-btn__wrapper
    padding: 0 16px
    font-size: 16px
    font-weight: normal
    text-transform: none
    &::before
      box-shadow: none
  &.remove-opacity, .remove-opacity:disabled
    opacity: 1!important

@media (max-width: 1130px)
  .calculator-button.q-btn
    &.next-step .q-btn__wrapper .q-btn__content
        min-width: 160px !important
    &.lease-inclusion-button .q-btn__wrapper .q-btn__content
        min-width: 140px !important

@media (max-width: 830px)
  .calculator-button.q-btn
    &.next-step .q-btn__wrapper .q-btn__content
        min-width: 140px !important
@media (max-width: 375px)
  .calculator-button.q-btn
    &.next-step
      width: 100%
      .q-btn__wrapper .q-btn__content
        min-width: 100% !important
    &.lease-inclusion-button
      margin-right: 0
      width: 100%
      .q-btn__wrapper .q-btn__content
        min-width: 100% !important
</style>
